import { Card, CardContent } from "../../../../components/ui/card";
import { Separator } from "../../../../components/ui/separator";
import { CheckoutItemSkeleton } from "../entrego-resolution/components/checkout-item-skeleton";
import { ImileCheckoutItemCard } from "./components/imile-checkout-item-card";
import { useImileCheckout } from "./hooks/use-imile-checkout";

export default function ImileCheckoutResolution() {
  const {
    checkoutList,
    isLoading,
    confirmCheckout,
    startDoc,
    submitRemessa,
    isConfirming,
    isStartingDoc,
    isSubmittingRemessa,
  } = useImileCheckout();

  if (isLoading) {
    return (
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-foreground">
            Resolução de Checkout iMile
          </h1>
          <p className="text-muted-foreground mt-1">
            Resolver pendências dos checkouts de iMile
          </p>
        </div>
        <div className="space-y-6">
          <CheckoutItemSkeleton />
          <Separator className="my-6" />
          <CheckoutItemSkeleton />
          <Separator className="my-6" />
          <CheckoutItemSkeleton />
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-foreground">
          Resolução de Checkout iMile
        </h1>
        <p className="text-muted-foreground mt-1">
          Resolver pendências dos checkouts de iMile
        </p>
      </div>

      {checkoutList.length === 0 && (
        <Card>
          <CardContent className="py-12">
            <div className="text-center">
              <h2 className="text-xl font-semibold text-foreground">
                Não há Checkouts de iMile para serem finalizados dos últimos 40
                dias
              </h2>
              <p className="text-muted-foreground mt-2">
                Se havia arquivo para o dia, confira se a base (DS) está
                cadastrada em Cadastro de franquias iMile — sem cadastro o
                romaneio não entra no checkout.
              </p>
            </div>
          </CardContent>
        </Card>
      )}

      {checkoutList.length > 0 && (
        <div className="space-y-6">
          {checkoutList.map((checkout, index) => (
            <div key={`${checkout.date_to_checkout}-${index}`}>
              <ImileCheckoutItemCard
                checkout={checkout}
                onConfirmCheckout={(filterDate, ops) =>
                  confirmCheckout({ filterDate, ops })
                }
                onStartDoc={(filterDate, ops) => startDoc({ filterDate, ops })}
                onSubmitRemessa={(filterDate, ops) =>
                  submitRemessa({ filterDate, ops })
                }
                isConfirming={isConfirming}
                isStartingDoc={isStartingDoc}
                isSubmittingRemessa={isSubmittingRemessa}
              />
              {index < checkoutList.length - 1 && (
                <Separator className="my-6" />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
